import axios from 'axios'

export const FIELD_NAMES: Record<string, string> = {
  password: 'Пароль',
  email: 'Email',
  full_name: 'ФИО',
  name: 'Название',
  amount: 'Сумма',
  period: 'Период',
  company_id: 'Компания',
  role: 'Роль',
  phone: 'Телефон',
  description: 'Описание',
  category: 'Категория',
}

function translateMessage(message: string): string {
  const text = message.trim()
  if (!text) return 'Произошла ошибка'

  if (text === 'Network Error') {
    return 'Ошибка сети. Проверьте подключение и доступность сервера.'
  }

  if (text === 'Request failed with status code 401') {
    return 'Неавторизовано'
  }

  const internalMap: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
    [/^Login failed$/i, () => 'Ошибка входа'],
    [/^Update failed$/i, () => 'Не удалось обновить данные'],
    [/^Failed to fetch products$/i, () => 'Не удалось загрузить товары'],
    [/^Failed to fetch product$/i, () => 'Не удалось загрузить товар'],
    [/^Failed to create product$/i, () => 'Не удалось создать товар'],
    [/^Failed to update product$/i, () => 'Не удалось обновить товар'],
    [/^Failed to delete product$/i, () => 'Не удалось удалить товар'],
    [/^Failed to export products$/i, () => 'Не удалось экспортировать товары'],
    [/^Failed to import products$/i, () => 'Не удалось импортировать товары'],
    [/^Failed to fetch categories$/i, () => 'Не удалось загрузить категории'],
    [/^Failed to create category$/i, () => 'Не удалось создать категорию'],
    [/^Failed to update category$/i, () => 'Не удалось обновить категорию'],
    [/^Failed to delete category$/i, () => 'Не удалось удалить категорию'],
    [/^Failed to fetch suppliers$/i, () => 'Не удалось загрузить поставщиков'],
    [/^Failed to create supplier$/i, () => 'Не удалось создать поставщика'],
    [/^Failed to update supplier$/i, () => 'Не удалось обновить поставщика'],
    [/^Failed to delete supplier$/i, () => 'Не удалось удалить поставщика'],
    [/^Failed to fetch legal entities$/i, () => 'Не удалось загрузить юридические лица'],
    [/^Failed to create legal entity$/i, () => 'Не удалось создать юридическое лицо'],
    [/^Failed to update legal entity$/i, () => 'Не удалось обновить юридическое лицо'],
    [/^Failed to delete legal entity$/i, () => 'Не удалось удалить юридическое лицо'],
    [/^Failed to fetch cabinets$/i, () => 'Не удалось загрузить кабинеты'],
    [/^Failed to fetch cabinet$/i, () => 'Не удалось загрузить кабинет'],
    [/^Failed to create cabinet$/i, () => 'Не удалось создать кабинет'],
    [/^Failed to update cabinet$/i, () => 'Не удалось обновить кабинет'],
    [/^Failed to delete cabinet$/i, () => 'Не удалось удалить кабинет'],
    [/^Failed to fetch companies$/i, () => 'Не удалось загрузить компании'],
    [/^Failed to create company$/i, () => 'Не удалось создать компанию'],
    [/^Failed to update company$/i, () => 'Не удалось обновить компанию'],
    [/^Failed to fetch users$/i, () => 'Не удалось загрузить пользователей'],
    [/^Failed to create user$/i, () => 'Не удалось создать пользователя'],
    [/^Failed to update user$/i, () => 'Не удалось обновить пользователя'],
    [/^Failed to delete user$/i, () => 'Не удалось удалить пользователя'],
    [/^Failed to fetch product groups$/i, () => 'Не удалось загрузить группы товаров'],
    [/^Failed to create product group$/i, () => 'Не удалось создать группу товаров'],
    [/^Failed to update product group$/i, () => 'Не удалось обновить группу товаров'],
    [/^Failed to delete product group$/i, () => 'Не удалось удалить группу товаров'],
    [/^Failed to export$/i, () => 'Не удалось выполнить экспорт'],
    [/^Failed to import$/i, () => 'Не удалось выполнить импорт'],
    [/^Failed to fetch planning grid$/i, () => 'Не удалось загрузить данные планирования'],
    [/^Failed to fetch budget entries$/i, () => 'Не удалось загрузить расходы'],
    [/^Failed to create budget entry$/i, () => 'Не удалось создать расход'],
    [/^Failed to update budget entry$/i, () => 'Не удалось обновить расход'],
    [/^Failed to delete budget entry$/i, () => 'Не удалось удалить расход'],
    [/^Failed to bulk update budget entries$/i, () => 'Не удалось массово обновить расходы'],
    [/^Failed to bulk upsert budget entries$/i, () => 'Не удалось массово сохранить расходы'],
    [/^Failed to copy budget entries$/i, () => 'Не удалось скопировать расходы'],
    [/^Failed to fetch loans$/i, () => 'Не удалось загрузить кредиты'],
    [/^Failed to create loan$/i, () => 'Не удалось создать кредит'],
    [/^Failed to update loan$/i, () => 'Не удалось обновить кредит'],
    [/^Failed to delete loan$/i, () => 'Не удалось удалить кредит'],
    [/^Failed to fetch Procurement report$/i, () => 'Не удалось загрузить отчёт по закупкам'],
    [/^Failed to fetch P&L report$/i, () => 'Не удалось загрузить отчёт P&L'],
    [/^Failed to fetch Cash Flow report$/i, () => 'Не удалось загрузить отчёт Cash Flow'],
    [/^Failed to fetch Balance Sheet report$/i, () => 'Не удалось загрузить отчёт Balance Sheet'],
    [/^Failed to fetch simplified balance$/i, () => 'Не удалось загрузить упрощённый баланс'],
    [/^Failed to recalculate financials$/i, () => 'Не удалось пересчитать финансы'],
  ]

  for (const [re, toRu] of internalMap) {
    const match = text.match(re)
    if (match) return toRu(match)
  }

  const pydanticV2Map: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
    [/^Input should be less than or equal to (\d+)\.?$/i, (m) => `Значение должно быть меньше или равно ${m[1]}`],
    [/^Input should be greater than or equal to (\d+)\.?$/i, (m) => `Значение должно быть больше или равно ${m[1]}`],
    [/^Input should be a valid email address\.?$/i, () => 'Введите корректный email'],
    [/^Field required\.?$/i, () => 'Поле обязательно'],
    [/^String should have at least (\d+) characters\.?$/i, (m) => `Строка должна содержать минимум ${m[1]} символов`],
    [/^String should have at most (\d+) characters\.?$/i, (m) => `Строка должна содержать максимум ${m[1]} символов`],
  ]

  for (const [re, toRu] of pydanticV2Map) {
    const match = text.match(re)
    if (match) return toRu(match)
  }

  const pydanticV1Map: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
    [/^ensure this value is less than or equal to (\d+)\.?$/i, (m) => `Значение должно быть меньше или равно ${m[1]}`],
    [/^ensure this value is greater than or equal to (\d+)\.?$/i, (m) => `Значение должно быть больше или равно ${m[1]}`],
    [/^field required\.?$/i, () => 'Поле обязательно'],
    [/^value is not a valid email address\.?$/i, () => 'Введите корректный email'],
    [/^ensure this value has at least (\d+) characters\.?$/i, (m) => `Строка должна содержать минимум ${m[1]} символов`],
    [/^ensure this value has at most (\d+) characters\.?$/i, (m) => `Строка должна содержать максимум ${m[1]} символов`],
  ]

  for (const [re, toRu] of pydanticV1Map) {
    const match = text.match(re)
    if (match) return toRu(match)
  }

  return text
}

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function getErrorMessage(error: unknown, defaultMessage = 'Произошла ошибка'): string {
  if (axios.isAxiosError(error) && error.response?.data) {
    const data: unknown = error.response.data
    if (isObject(data)) {
      const detail = data.detail
      if (typeof detail === 'string') {
        return translateMessage(detail)
      }
      if (Array.isArray(detail)) {
        const parts = detail
          .map((item: unknown) => {
            if (typeof item === 'string') {
              return translateMessage(item)
            }
            if (isObject(item) && typeof item.msg === 'string') {
              const msg = translateMessage(String(item.msg))
              const loc = item.loc
              if (Array.isArray(loc) && loc.length > 0) {
                const fieldKey = String(loc[loc.length - 1])
                const fieldName = FIELD_NAMES[fieldKey]
                if (fieldName) {
                  return `${fieldName}: ${msg.charAt(0).toLowerCase() + msg.slice(1)}`
                }
              }
              return msg
            }
            try {
              return JSON.stringify(item)
            } catch {
              return String(item)
            }
          })
          .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
        return parts.join('; ')
      }
      try {
        return translateMessage(JSON.stringify(data))
      } catch {
        return translateMessage(defaultMessage)
      }
    }
    try {
      return translateMessage(JSON.stringify(data))
    } catch {
      return translateMessage(defaultMessage)
    }
  }
  if (error instanceof Error) return translateMessage(error.message)
  return translateMessage(defaultMessage)
}
